import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { moveRowsToInboxPlusPivot } from '../actions/actionCreators/inboxPlusTriageActions';
import { orchestrator } from 'satcheljs';
import {
    listViewStore,
    getRowIdsFromRowKeys,
    MailFolderTableQuery,
    InboxClassificationFilter,
    isItemOfMessageType,
} from 'owa-mail-list-store';
import getHashtagForInboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/selectors/getHashtagForInboxClassificationFilter';
import InferenceClassification from 'owa-service/lib/contract/InferenceClassification';
import updateHashtagsService from '../services/updateHashtagsService';
import { mailStore } from 'owa-mail-store';
import Message from 'owa-service/lib/contract/Message';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';

orchestrator(moveRowsToInboxPlusPivot, actionMessage => {
    const tableView = listViewStore.tableViews.get(actionMessage.tableViewId);
    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            break;

        case ReactListViewType.Message:
            moveItemsToInboxPlusPivotInternal(
                actionMessage.rowKeys,
                actionMessage.destinationPivot,
                actionMessage.tableViewId
            );
            break;
    }
});

// Orchestrator to remove the row locally and make a call to UpdateItem to update the hashtag properties
function moveItemsToInboxPlusPivotInternal(
    rowKeys: string[],
    destinationPivot: InboxClassificationFilter,
    tableViewId: string
) {
    let inferenceClassificationFilterToWrite: InferenceClassification;

    const itemIds = getRowIdsFromRowKeys(rowKeys, tableViewId);
    const tableView = listViewStore.tableViews.get(tableViewId);
    const tableQuery = tableView.tableQuery as MailFolderTableQuery;

    // If user is moving to F/O we need to update the classificaiton filter as well as the hashtag properties
    if (
        destinationPivot === InboxClassificationFilter.Focused ||
        destinationPivot === InboxClassificationFilter.Other
    ) {
        inferenceClassificationFilterToWrite =
            destinationPivot === InboxClassificationFilter.Focused ? 'Focused' : 'Other';
    }

    const hashtagToWrite = getHashtagForInboxClassificationFilter(destinationPivot);
    const hashtagBaseToWrite = getHashtagForInboxClassificationFilter(
        tableQuery.inboxClassificationFilter
    );

    const itemContexts = itemIds.map(itemIdValue => {
        const item = mailStore.items.get(itemIdValue);
        let isReadValue;

        if (isItemOfMessageType(item)) {
            isReadValue = (item as Message).IsRead;
        } else {
            // Default to isRead = true when not a mail item
            isReadValue = true;
        }

        return {
            itemId: itemIdValue,
            conversationId: item.ConversationId.Id,
            isRead: isReadValue,
            mailboxInfo: item.MailboxInfo,
        };
    });

    deleteItemsStoreUpdate(itemContexts, tableView.tableQuery.folderId);

    updateHashtagsService(
        itemIds,
        hashtagToWrite,
        hashtagBaseToWrite,
        inferenceClassificationFilterToWrite
    );
}
